const editProfileTransPath = 'editProfile.msg.error.';

 const editProfileTranslations = {
    ERROR_FIRST_NAME: editProfileTransPath + "firstNameValidation",
    ERROR_LAST_NAME: editProfileTransPath + "lastNameValidation",
    ERROR_PHONE_NUMBER: editProfileTransPath + "phoneValidation",

}

export default editProfileTranslations